
import {Component, Prop, Vue} from "vue-property-decorator";

import {Line, mixins} from "vue-chartjs";

// import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';

//@ts-ignore
// import {SetOne9}  from "chartjs-plugin-colorschemes/src/colorschemes/colorschemes.brewer";

@Component({
  components: {},
  mixins: [
    mixins.reactiveProp,
    Line
  ]
})
export default class BaseAgencyCostPlot extends Vue {

  @Prop() chartData!: any;


  options = {
    responsive: true,
    animation: {
      duration: 0
    },
    maintainAspectRatio: false,
    // plugins: {
    // colorschemes: {
    //   scheme: SetOne9,
    //   fillAlpha: 0.1
    // }
    // },
    scales: {
      xAxes: [{
        type: "linear",
        position: "bottom",
        ticks: {
          precision: 0
        },
        scaleLabel: {
          display: true,
          labelString: "Years",
          fontSize: 16
        }
      }],
      yAxes: [{
        type: "linear",
        position: "left",
        ticks: {
          precision: 0
        },
        scaleLabel: {
          display: true,
          labelString: "Cumulative cost, $",
          fontSize: 16
        }
      }]

    }
  };


  mounted() {
    //@ts-ignore
    this.renderChart(this.chartData, this.options);
  }

}

